export default __webpack_public_path__ + "static/media/Pistol_7.22e8f73b.png";